import CalendarIcon from '@svg/calendar.svg';
import ClockIcon from '@svg/clock.svg';
import EmailIcon from '@svg/email.svg';
import HashIcon from '@svg/hash.svg';
import ResourceIcon from '@svg/resource.svg';
import TextIcon from '@svg/text.svg';
import ToggleIcon from '@svg/toggle.svg';
import TreeIcon from '@svg/tree-structure.svg';
import UserIcon from '@svg/user.svg';
import { FieldIconType } from 'mapistry-shared';
import React from 'react';

export const ColumnIconFactory = ({
  fieldIconType,
}: {
  fieldIconType: FieldIconType;
}): React.ReactElement | null => {
  switch (fieldIconType) {
    case FieldIconType.NUMBER:
      return <HashIcon />;
    case FieldIconType.BOOLEAN:
      return <ToggleIcon />;
    case FieldIconType.TEXT:
      return <TextIcon />;
    case FieldIconType.DATE:
      return <CalendarIcon />;
    case FieldIconType.TIME:
      return <ClockIcon />;
    case FieldIconType.TREE:
      return <TreeIcon />;
    case FieldIconType.USER:
      return <UserIcon />;
    case FieldIconType.EMAIL:
      return <EmailIcon />;
    case FieldIconType.RESOURCE:
      return <ResourceIcon />;
    case FieldIconType.NO_ICON:
      return null;
    default: {
      const exhaustiveCheck: never = fieldIconType;
      throw new Error(`Invalid column type - ${exhaustiveCheck}`);
    }
  }
};
